import { IconLabel } from "@App/Components/atoms/common/IconLabel";
import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

export const MahleAirConditioningBadge: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <IconLabel
      icon={<img src="/images/icons/MAHLE_icon_AC.png" className="w-5 h-5 object-contain" alt="" />}
      text={t("garageList.certifiedAirConditioningExpert")}
    />
  );
};
